// Errors are plain objects, not Error subclasses: `instanceof` against transpiled built-ins is unreliable on
// the oldest TV engines. `message` is always the fixed text for the code, never anything that came from an
// exception or from user input, so it can be shown as is.

export const PLAYLIST_ERROR_MESSAGES = {
    PLAYLIST_ALREADY_EXISTS: "This playlist already exists.",
    INVALID_PLAYLIST: "The playlist data is not valid.",
    STORAGE_ERROR: "The playlist could not be saved. Please try again.",
    QUOTA_EXCEEDED: "There is not enough storage space on this device.",
    STORAGE_UNAVAILABLE: "Storage is not available on this device.",
    UNSUPPORTED_SCHEMA: "Saved playlists were created by a newer version of the app.",
    NOT_FOUND: "This playlist no longer exists.",
};

export const playlistErrorMessage = (code) => PLAYLIST_ERROR_MESSAGES[code] || PLAYLIST_ERROR_MESSAGES.STORAGE_ERROR;

export const storageError = (code, reason) => ({
    name: "PlaylistStorageError",
    code,
    // short machine label for logs ("set_item", "verify_failed", ...)
    reason,
    message: playlistErrorMessage(code),
});

export const isStorageError = (e) => !!e && typeof e === "object" && e.name === "PlaylistStorageError";

export const failure = (code) => ({
    success: false,
    code,
    message: playlistErrorMessage(code),
});

// DOMException.code 22 is the legacy QUOTA_EXCEEDED_ERR; 1014 is Gecko's NS_ERROR_DOM_QUOTA_REACHED.
const isQuotaError = (e) => !!e && (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED" || e.code === 22 || e.code === 1014);

// Only `name` is read from the exception, never `message`: engines are free to put anything in it.
export const classifyError = (e, fallback) => {

    if (isStorageError(e)) return e;

    const name = e && typeof e.name === "string" ? e.name : "";

    if (isQuotaError(e)) return storageError("QUOTA_EXCEEDED", name || "quota");

    return storageError(fallback.code, name ? `${fallback.reason}:${name}` : fallback.reason);

};
